module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [_c('p', {
    class: _vm.classes
  }, [(['checkbox'].indexOf(_vm.type) === -1) ? _c('label', {
    staticClass: "label",
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }) : _vm._e(), _vm._v(" "), _c('form-control', {
    ref: "form_control",
    attrs: {
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "type": _vm.type,
      "value": _vm.value,
      "true-value": _vm.trueValue,
      "false-value": _vm.falseValue,
      "required": _vm.required,
      "mask": _vm.mask,
      "save-mask": _vm.saveMask,
      "options": _vm.options,
      "option_name": _vm.option_name,
      "option_value": _vm.option_value
    },
    on: {
      "input": _vm.updateInput,
      "event": _vm.passEvent
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    },
    slot: "label"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "expand-extra-tiny"
    }
  }, [(_vm.error) ? _c('small', {
    staticClass: "form-info"
  }, [_c('ul', _vm._l((_vm.error), function(text) {
    return _c('li', [_vm._v("\n                            " + _vm._s(text) + "\n\n                        ")])
  }), 0)]) : _vm._e()])], 1), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cfd331f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/misc/FormGroup.vue
// module id = 564
// module chunks = 0